// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import React from 'react';
import TransactionRellocationLog from '../shared/transaction-reallocation-log';

function ReallocationLogPage () {

    return (
        <AuthenticatedPage className="atp-page atp-reallocation-log-page">
            <TransactionRellocationLog transactionLog={false} />
        </AuthenticatedPage>
    );

}
ReallocationLogPage.displayNAme = 'ReallocationLogPage';

export default ReallocationLogPage;
